export interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
}

export interface LinkItem {
  name: string;
  url: string;
  icon?: string;
}

export interface MenuSection {
  name: string;
  links: LinkItem[];
}

export interface LocalMenuSection {
  name: string;
  enableCustomLocalMenu: boolean;
  links: LinkItem[];
}

export interface MenuConfig {
  global: MenuSection;
  local: LocalMenuSection;
}

export interface LoadingConfig {
  isLoading: boolean;
  duration: number; // in milliseconds
}

export interface AppConfig {
  keycloak: KeycloakConfig;
  defaultLink: LinkItem;
  menuViewType: string;
  cookieName: string;
  menu: MenuConfig;
  loading?: LoadingConfig;
  allowedGlobalDomain: string;
  whitelistedUrls: string;
}


const DEFAULT_CONFIG: AppConfig = {
  keycloak: {
    url: 'https://keycloak.ds2.icelab.cloud',
    realm: 'ds2',
    clientId: 'dashbtn'
  },
  defaultLink: { name: 'Portal', url: 'https://portal.ds2.icelab.cloud' },
  menuViewType: 'grid',
  cookieName: 'ZDZW_cookie',
  menu: {
    global: {
      name: 'Applications',
      links: []
    },
    local: {
      name: 'Applications',
      enableCustomLocalMenu: true,
      links: []
    }
  },
  loading: {
    isLoading: true,
    duration: 800
  },
  allowedGlobalDomain: '',
  whitelistedUrls: ''
};

// Fetch config from API
class ConfigService {
  private static instance: ConfigService;
  private _config: AppConfig = DEFAULT_CONFIG;

  static getInstance() {
    if (!ConfigService.instance) {
      ConfigService.instance = new ConfigService();
    }
    return ConfigService.instance;
  }

  async fetchConfig(portalApiUrl: string) {
    try {
      const res = await fetch(portalApiUrl + '/developer/dashbuttons/config');
      if (!res.ok) throw new Error('Failed to fetch config');
      const data = await res.json();
      this._config = { ...DEFAULT_CONFIG, ...data }; // Merge API data with defaults
    } catch (e) {
      console.warn('Using default config due to API failure', e);
      this._config = DEFAULT_CONFIG; // fallback to defaults
    }

    return this._config;
  }

  /**
   * Return cached config without calling API
   */
  get config() {
    return this._config;
  }
}

export const configService = ConfigService.getInstance();